import React from 'react';
import { 
  Facebook, 
  Instagram, 
  Linkedin,
  MessageCircle
} from 'lucide-react';

// TikTok icon component (not in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/share/1GXQYFCPYH/',
  instagram: 'https://www.instagram.com/ioana_alexandra_balasa',
  tiktok: 'https://www.tiktok.com/@oana_balasa',
  linkedin: 'https://www.linkedin.com/in/oana-balasa-940355206',
  whatsapp: 'https://wa.me/40766475946'
};

const SocialMediaLinks = ({ className = '', variant = 'default' }) => {
  const socialMedia = [
    {
      name: 'Facebook',
      icon: Facebook,
      url: SOCIAL_LINKS.facebook,
      color: variant === 'footer' ? 'hover:text-blue-400' : 'bg-blue-600 hover:bg-blue-700 text-white'
    },
    {
      name: 'Instagram',
      icon: Instagram,
      url: SOCIAL_LINKS.instagram,
      color: variant === 'footer' ? 'hover:text-pink-400' : 'bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 hover:opacity-90 text-white'
    },
    {
      name: 'TikTok',
      icon: TikTokIcon,
      url: SOCIAL_LINKS.tiktok,
      color: variant === 'footer' ? 'hover:text-white' : 'bg-black hover:bg-gray-800 text-white'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: SOCIAL_LINKS.linkedin,
      color: variant === 'footer' ? 'hover:text-blue-500' : 'bg-blue-700 hover:bg-blue-800 text-white'
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      url: SOCIAL_LINKS.whatsapp,
      color: variant === 'footer' ? 'hover:text-green-400' : 'bg-green-500 hover:bg-green-600 text-white'
    }
  ];

  if (variant === 'footer') {
    return (
      <div className={`flex items-center gap-4 ${className}`}>
        {socialMedia.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-slate-400 ${social.color} transition-colors`}
            title={social.name}
          >
            <social.icon className="w-5 h-5" />
          </a>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {socialMedia.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-10 h-10 rounded-full ${social.color} flex items-center justify-center transition-transform hover:scale-110`}
          title={social.name}
          data-testid={`social-${social.name.toLowerCase()}`}
        >
          <social.icon className="w-5 h-5" />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaLinks;
